export interface NoteData {
  height: number;
  note: string;
  top_height?: number;
  symbol?: string;
  id?: string | number;
}
